/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Bell_ByInputs */

const en_bell_by = /** @type {(inputs: Bell_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`by ${i?.names}`)
};

/**
* | output |
* | --- |
* | "by {names}" |
*
* @param {Bell_ByInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_by = /** @type {((inputs: Bell_ByInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_ByInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_by(inputs)
});